import { createReducer } from '@reduxjs/toolkit'
import {
  Added,
  Connection,
  InvoiceKSeF,
  Resource,
  ImportData,
  SummaryData,
} from 'shared/types'
import * as actions from './actions'
import { initResource, setFailed, setPending, setSucceeded } from 'shared/utils'

interface State {
  connection: Resource<Connection>
  added: Resource<Added>
  ksefInvoices: Resource<InvoiceKSeF[]>
  invoicesToSend: Resource<InvoiceKSeF[]>
  imports: Resource<ImportData[]>
  summary: Resource<SummaryData>
  downloadReport: Resource
  hideMessage: Resource
}

const initialState: State = {
  connection: initResource({
    connected: null,
    errorCode: null,
  }),
  added: initResource(),
  ksefInvoices: initResource(),
  invoicesToSend: initResource(),
  imports: initResource(),
  summary: initResource(),
  downloadReport: initResource(),
  hideMessage: initResource(),
}

export default createReducer(initialState, builder =>
  builder
    .addCase(actions.updateToken.pending, state => {
      setPending(state.connection)
    })
    .addCase(actions.updateToken.fulfilled, state => {
      setSucceeded(state.connection)
    })
    .addCase(actions.updateToken.rejected, (state, action) => {
      setFailed(state.connection, action.error.code)
    })
    .addCase(actions.deleteToken.pending, state => {
      setPending(state.connection)
    })
    .addCase(actions.deleteToken.fulfilled, state => {
      setSucceeded(state.connection)
    })
    .addCase(actions.deleteToken.rejected, (state, action) => {
      setFailed(state.connection, action.error.code)
    })
    .addCase(actions.checkTokenActivity.pending, state => {
      setPending(state.connection)
    })
    .addCase(actions.checkTokenActivity.fulfilled, (state, { payload }) => {
      setSucceeded(state.connection, payload)
    })
    .addCase(actions.checkTokenActivity.rejected, (state, action) => {
      setFailed(state.connection, action.error.code)
    })
    .addCase(actions.checkAdded.pending, state => {
      setPending(state.added)
    })
    .addCase(actions.checkAdded.fulfilled, (state, { payload }) => {
      setSucceeded(state.added, payload)
    })
    .addCase(actions.checkAdded.rejected, (state, action) => {
      setFailed(state.added, action.error.code)
    })
    .addCase(actions.fetchKsefInvoices.pending, state => {
      setPending(state.ksefInvoices)
    })
    .addCase(actions.fetchKsefInvoices.fulfilled, (state, response) => {
      setSucceeded(state.ksefInvoices)
      state.ksefInvoices.data = response.payload.invoices
      state.connection.data.connected = response.payload.connected
    })
    .addCase(actions.fetchKsefInvoices.rejected, (state, action) => {
      setFailed(state.ksefInvoices, action.error.code)
    })
    .addCase(actions.sendInvoices.pending, state => {
      setPending(state.invoicesToSend)
    })
    .addCase(actions.sendInvoices.fulfilled, state => {
      setSucceeded(state.invoicesToSend)
    })
    .addCase(actions.sendInvoices.rejected, (state, action) => {
      setFailed(state.invoicesToSend, action.error.code)
    })
    .addCase(actions.getKsefImports.pending, state => {
      setPending(state.ksefInvoices)
    })
    .addCase(actions.getKsefImports.fulfilled, (state, response) => {
      setSucceeded(state.ksefInvoices)
      state.imports.data = response.payload
    })
    .addCase(actions.getKsefImports.rejected, (state, action) => {
      setFailed(state.ksefInvoices, action.error.code)
    })
    .addCase(actions.getImportSummary.pending, state => {
      setPending(state.ksefInvoices)
    })
    .addCase(actions.getImportSummary.fulfilled, (state, response) => {
      setSucceeded(state.ksefInvoices)
      state.summary.data = response.payload
    })
    .addCase(actions.getImportSummary.rejected, (state, action) => {
      setFailed(state.ksefInvoices, action.error.code)
    })
    .addCase(actions.downloadReportFile.pending, state => {
      setPending(state.downloadReport)
    })
    .addCase(actions.downloadReportFile.fulfilled, state => {
      setSucceeded(state.downloadReport)
    })
    .addCase(actions.downloadReportFile.rejected, state => {
      setFailed(state.downloadReport)
    })
    .addCase(actions.hideMessage.pending, state => {
      setPending(state.hideMessage)
    })
    .addCase(actions.hideMessage.fulfilled, state => {
      setSucceeded(state.hideMessage)
    })
    .addCase(actions.hideMessage.rejected, state => {
      setFailed(state.hideMessage)
    })
)
